import React from 'react'
import styled from 'styled-components'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  title: React.ReactNode
} & React.PropsWithChildren &
  ClassNameProps

export const DrawerHeader: React.FC<Props> = ({ title }) => {
  return (
    <>
      <Root>
        <Border />
        <Handle />
        {title ? <Title>{title}</Title> : undefined}
      </Root>
    </>
  )
}

const Root = styled.div`
  padding-top: 8px;
  padding-bottom: 8px;
  display: grid;
  justify-items: center;
  gap: 8px;

  position: absolute;
  inset: 0;
  bottom: auto;
`

const Border = styled.div`
  height: 1px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255 255 255 / 5%),
    transparent
  );
`

const Handle = styled.div`
  border-radius: 2px;
  width: 32px;
  height: 4px;
  background: var(--backgroundA-4);
`

const Title = styled.div`
  color: var(--textA-9);
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-transform: uppercase;
`
